import { render } from "./CustomerCollection.vue?vue&type=template&id=1ad80e01&scoped=true"
import script from "./CustomerCollection.vue?vue&type=script&lang=js"
export * from "./CustomerCollection.vue?vue&type=script&lang=js"

import "./CustomerCollection.vue?vue&type=style&index=0&id=1ad80e01&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/staging-package-front-service/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ad80e01"]])

export default __exports__